export interface BuildInfo {
  commit: string | null;
  source: 'cloudflare' | 'local' | 'unknown';
  development: boolean;
}

declare const __DIGITILES_BUILD_INFO__: BuildInfo;

/** Replaced in the loaded JavaScript at build time; no network or storage lookup. */
export const buildInfo: BuildInfo =
  typeof __DIGITILES_BUILD_INFO__ === 'undefined'
    ? { commit: null, source: 'unknown', development: import.meta.env.DEV }
    : __DIGITILES_BUILD_INFO__;
